import { render, staticRenderFns } from "./InputSlug.vue?vue&type=template&id=5befe85b&scoped=true&"
import script from "./InputSlug.vue?vue&type=script&lang=js&"
export * from "./InputSlug.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5befe85b",
  null
  
)

export default component.exports